"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCustomColor = exports.StyledCustomColorContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, toRemString } = ui_common_components_1.utils;
exports.StyledCustomColorContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.XXSmall)};
    height: ${rem(theme.Components.PopupMenu.Button.Size)};
    width: ${rem(theme.Components.PopupMenu.Button.Size)};
  `}
`;
const BeforePosition = 5;
exports.StyledCustomColor = styled_components_1.default.div `
  display: flex;
  position: relative;

  & > ::before {
    content: '';
    ${({ theme }) => (0, styled_components_1.css) `
      background-color: ${theme.Color.Neutrals.Paper};
      height: ${rem(10)};
      width: ${rem(10)};
      bottom: ${rem(BeforePosition)};
      left: ${rem(BeforePosition)};
      border-radius: 50%;
      position: absolute;
      box-shadow: ${toRemString([0, 0, 0, 0.5])} ${theme.Color.Neutrals.Border};
      display: inline-block;
      z-index: 2;
    `}
  }
`;
//# sourceMappingURL=CustomColor.styles.js.map